module.exports = __webpack_public_path__ + "img/drone_04_H.b406b586.jpg";